/**
 * Safely reads a value from a record keyed by a dynamic (non-literal) key.
 *
 * Prefer this over `record[key]` when `key` is a variable: direct bracket
 * access with a non-literal key is a potential object-injection / prototype
 * -pollution vector (flagged by security/detect-object-injection) since it can
 * read inherited properties (e.g. `__proto__`, `toString`) if `key` ever
 * collides with them. `Object.entries().find()` only ever matches the
 * object's own enumerable string-keyed entries, so it can't be tricked into
 * returning a prototype property.
 */
export function getRecordValue<T extends object, K extends keyof T>(
  record: T,
  key: K
): T[K] | undefined {
  const entries = Object.entries(record) as [string, T[K]][];
  return entries.find(([k]) => k === String(key))?.[1];
}
